//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';

// === API ===
import { serverRestart } from 'api/prokey/prokey.axios';
import { systemRestart } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function SystemRestartDialog( { is_open, onClose } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
    }
  }

  const CONTAINER = {
    sx              : _styles.container,
    open            : is_open,
    onClose         : onClose,
    ariaLabelledby  : 'alert-dialog-title',
    ariaDescribedby : 'alert-dialog-description',
  }

  const CONFIRM = {
    color     : 'primary'     ,
    onClick   : handleConfirm ,
    autoFocus : true          ,
    children  : [ 'Confirm' ] ,
  }

  const ABORT = {
    color     : 'primary'   ,
    onClick   : onClose     ,
    autoFocus : true        ,
    children  : [ 'Abort' ] ,
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  async function handleConfirm() {
    //-----------------------------------------------------------------
    systemRestart();
    onClose();
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Dialog { ...CONTAINER } >
        <DialogTitle id='alert-dialog-title'>{'Confirm System Restart'}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to restart the system? Be advised, all users will be kicked out and their current task
            progress will be lost.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button { ...ABORT   } />
          <Button { ...CONFIRM } />
        </DialogActions>
      </Dialog>
    )
  }

  //#endregion

  return display();
}